import ESSSTPRServiceDetail from "./ESSSTPRServiceDetail";

export default ESSSTPRServiceDetail;
